export default __webpack_public_path__ + "static/media/background-login.5261be89.jpg";